import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import AiLogo from 'assets/images/ai.svg?react';
import './LangflowButton.scss';

interface LangflowButtonProps {
  onClick?: () => void;
  isOpen?: boolean;
}

const LangflowButton: React.FC<LangflowButtonProps> = ({ onClick, isOpen }) => {
  return (
    <IconButton onClick={onClick} className="langflow-button" type="button">
      {isOpen ? <CloseIcon /> : <AiLogo />}
    </IconButton>
  );
};

export default LangflowButton;
